<template>
  <div class="summary">
    <div class="content-container" :class="expandClass">
      <div class="content" v-html="summary" ref="summaryContent"></div>
    </div>
    <div class="readmore" v-if="isNeedExpand">
      <a class="readmore-btn" v-if="!isExpand" @click.prevent="doExpand">すべて表示</a>
      <a class="readmore-btn" v-else @click.prevent="doCollapse">閉じる</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DocumentSummary',
    props: {
      summary: {
        type: String
      }
    },
    data () {
      return {
        isNeedExpand: false,
        isExpand: false
      }
    },
    computed: {
      expandClass () {
        return {
          'summary-expand': this.isNeedExpand && this.isExpand,
          'summary-collapse': this.isNeedExpand && !this.isExpand
        }
      }
    },
    created () {
      window.addEventListener('resize', this.computeExpandDisplay)
    },
    mounted () {
      this.computeExpandDisplay()
    },
    methods: {
      doExpand () {
        this.isExpand = true
      },
      doCollapse () {
        this.isExpand = false
      },
      computeExpandDisplay () {
        if (this.$refs.summaryContent) {
          const summaryContent = this.$refs.summaryContent
          if (summaryContent.clientHeight < 80) {
            this.isNeedExpand = false
            this.isExpand = false
          } else {
            this.isNeedExpand = true
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .summary {
    padding: 15px 0;
    width: 100%;
    position: relative;
    flex: 1 0 auto;

    .summary-expand {
      overflow: initial;
      height: auto;
    }

    .summary-collapse {
      height: 80px;
      overflow: hidden;
    }

    .content-container {
      margin-bottom: 10px;

      .content {
        font-weight: 400;
        font-size: 13px;
      }
    }

    .readmore {
      width: 100%;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      .readmore-btn {
        font-size: 12px;
        text-decoration: underline !important;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
</style>
